import an1 from '../../assets/angular/an-1.png'
import an2 from '../../assets/angular/an-2.png'
import an3 from '../../assets/angular/an-3.png'
import an4 from '../../assets/angular/an-4.png'
import an5 from '../../assets/angular/an-5.png'
import an6 from '../../assets/angular/an-6.png'



import all1 from '../../assets/all/EPrescription-mobile-app.png'
import all2 from '../../assets/all/EPrescription.png'
import all3 from '../../assets/all/NGO Microfinance Fintech Software.jpg'
import all4 from '../../assets/all/colorchains.png'
import all5 from '../../assets/all/erp.png'
import all6 from '../../assets/all/hospital-erp.png'
import all7 from '../../assets/all/multivendor.jpg'
import all8 from '../../assets/all/pharmacy desktop application.png'
import all9 from '../../assets/all/reatails pos desktop application.png'
import all10 from '../../assets/all/single-vendor-ecommer.jpg'



const data = [
  {
    id: 1,
    category: "Web Application",
    title: "Color Chains Platform",
    desc: "A creative UI/UX tool for color management and design workflows",
    demo: "https://colorchains.xyz/",
    github: "https://github.com/raisulislampiaus",
    images: [all4]
  },
  {
    id: 2,
    category: "Mobile Application",
    title: "E-Prescription Mobile App",
    desc: "A mobile application for electronic prescription management developed with modern mobile technologies",
    demo: "https://prescription.pairdevssolutions.xyz/login",
    github: "https://github.com/raisulislampiaus",
    images: [all1]
  },
  {
    id: 3,
    category: "Web Application",
    title: "E-Prescription Web Platform",
    desc: "A web-based electronic prescription management system for healthcare providers",
    demo: "https://prescription.pairdevssolutions.xyz/login",
    github: "https://github.com/raisulislampiaus",
    images: [all2]
  },
  {
    id: 4,
    category: "Fintech Application",
    title: "NGO Microfinance Fintech Software",
    desc: "A comprehensive microfinance management solution for NGOs and financial institutions",
    demo: "https://github.com/raisulislampiaus",
    github: "https://github.com/raisulislampiaus",
    images: [all3]
  },
  {
    id: 5,
    category: "Enterprise Software",
    title: "ERP Management System",
    desc: "A comprehensive enterprise resource planning system for business management",
    demo: "https://github.com/raisulislampiaus",
    github: "https://github.com/raisulislampiaus",
    images: [all5]
  },
  {
    id: 6,
    category: "Healthcare Software",
    title: "Hospital ERP System",
    desc: "A specialized ERP solution designed for hospital and healthcare management",
    demo: "https://github.com/raisulislampiaus",
    github: "https://github.com/raisulislampiaus",
    images: [all6]
  },
  {
    id: 7,
    category: "Web Application",
    title: "Multi-vendor E-commerce",
    desc: "A comprehensive multi-vendor e-commerce platform with advanced features",
    demo: "https://github.com/raisulislampiaus",
    github: "https://github.com/raisulislampiaus",
    images: [all7]
  },
  {
    id: 8,
    category: "Desktop Application",
    title: "Pharmacy Desktop Application",
    desc: "A desktop application for pharmacy management and inventory control",
    demo: "https://github.com/raisulislampiaus",
    github: "https://github.com/raisulislampiaus",
    images: [all8]
  },
  {
    id: 9,
    category: "Desktop Application",
    title: "Retail POS Desktop Application",
    desc: "A point-of-sale desktop application for retail business management",
    demo: "https://github.com/raisulislampiaus",
    github: "https://github.com/raisulislampiaus",
    images: [all9]
  },
  {
    id: 10,
    category: "Web Application",
    title: "Single Vendor E-commerce",
    desc: "A streamlined e-commerce solution for single vendor businesses",
    demo: "https://github.com/raisulislampiaus",
    github: "https://github.com/raisulislampiaus",
    images: [all10]
  },
   {
    id: 11,
    category: "Web Application",
    title: "Full Stack Admin Dashboard MEAN STACK",
    desc: "An ecommerce Admin-Dashboard application developed using Angular  , node , mongodb, express.js",
    demo: "https://angular-admin-dashboard-eta.vercel.app/",
    github: "https://github.com/raisulislampiaus/angular-admin-dashboard",
    images: [an1,an2,an3,an4,an5,an6]
  },
  
];

export default data;
